const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const SlowedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'slowed';
	condition.ConditionClass = SlowedCondition;

	const extant = BattleCalc.getCondition( owner, 'slowed' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};

SlowedCondition.fromCopy = function(cState, owner, instigator, battleState) {
	const elapsed = Date.now() - cState.startTime;
	const remainingDuration = Math.max(0, cState.duration - elapsed);
	return SlowedCondition(instigator, owner, battleState, remainingDuration);
};

module.exports = SlowedCondition
